import { BetslipApplicationState } from "../../store/state/BetslipApplicationState";
import { MapStateToPropsFactory } from "react-redux";
import { getSportsbookBettingReviewLines } from "../../store/state/sportsbook-betting/sportsbook-betting-selectors";
import { getIsBetslipLoaded } from "../../store/state/betslip-module/betslip-module-selectors";
import { formatOdds } from "@ppb/formatters";
import { currencyFormatWithDecimalPlaces } from "../../formatters/currency-adapter";
import { toOdds } from "../../formatters/odds-adapter";
import { createPreviewSelectionsSelector, PreviewSelection } from "./preview-line-mapper";
import type { BetslipLocalization, SportsbookBetslipPreferences } from "../../contract";

type CardProps = {
  order: number;
  runners: PreviewSelection[];
  odd: string;
  payout: string;
};

export type StateProps = CardProps | Record<string, never>;

export type ContainerProps = {
  id: string;
  order: number;
  isLast?: boolean;
  localization: BetslipLocalization;
  preferences: SportsbookBetslipPreferences;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps, ContainerProps, BetslipApplicationState> = () => {
  const getPreviewSelections = createPreviewSelectionsSelector();

  return (state: BetslipApplicationState, { id, order, localization, preferences }: ContainerProps): StateProps => {
    const isBetslipLoaded = getIsBetslipLoaded(state);

    if (!isBetslipLoaded) {
      return {};
    }

    const lines = getSportsbookBettingReviewLines(state);
    const { odds, potentialReturns } = lines[id];

    return {
      order: order + 1,
      runners: getPreviewSelections(state, id, localization),
      odd: odds ? formatOdds(toOdds(odds), preferences.oddsDisplay) : "",
      payout: currencyFormatWithDecimalPlaces({
        ...localization,
        value: potentialReturns || 0,
        decimalPlaces: 2,
      }),
    };
  };
};
